export var PRODUCT_TYPE_PURCHASE = 'PURCHASE';
export var PRODUCT_TYPE_REFINANCE = 'REFINANCE';
export var OFFER_LOAN_TYPE_CONVENTIONAL = 'CONVENTIONAL';
export var OFFER_LOAN_TYPE_FHA = 'FHA';
export var OFFER_LOAN_TYPE_JUMBO = 'JUMBO';
export var OFFER_LOAN_TYPE_VA = 'VA';
export var OFFER_LOAN_TYPE_USDA = 'USDA';
export var OFFER_LOAN_TYPE_CASHOUT = 'CASHOUT';
export var OFFER_LOAN_TYPE_HEL = 'HEL';
export var OFFER_LOAN_TYPE_HELOC = 'HELOC';
export var NAMED_QUERY_HLM = 'mortgages_offers_hlm';